
import { SearchSelect, Cooks, Ingredients, MenuId } from '@/entity/entity'
import { Route } from '@/entity/route'
import Vue from 'vue'
import { StorageAccess } from '@/scripts/storage-access'
import router from '@/router'
import { generateId } from '@/scripts/util'
import { originOptions } from '@/scripts/data'
import SelectOrigin from '@/component/SelectOrigin.vue'
export default Vue.extend({
  name: 'SearchByCategory',
  components: {
    SelectOrigin
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    searchByGenre: {
      type: Object as () => SearchSelect,
      required: true
    },
    searchByMethod: {
      type: Object as () => SearchSelect,
      required: true
    },
    searchByIngredient: {
      type: Object as () => SearchSelect,
      required: true
    },
    cooks: {
      type: Object as () => Cooks,
      required: true
    },
    ingredients: {
      type: Object as () => Ingredients,
      required: true
    },
    stepInit: {
      default: 1
    }
  },
  data: function () : {
    step: 1 | 2 | 3,
    searchId: string,
    cookId: string,
    searchLink: string,
    listLink: string,
    searchByCategory: SearchSelect,
    dataOriginOptions: {value: string, name: string}[],
    originSelect: {id: string, origin: string}[],
    focusNoSelect: boolean,
    } {
    return {
      step: this.stepInit as 1 | 2 | 3,
      searchId: this.type === 'cari' ? '006' : this.type === 'main-food' ? '007' : '',
      cookId: '',
      searchLink: Route.Search.path,
      listLink: Route.MenuList.path,
      searchByCategory: this.type === 'genre' || this.type === 'cari' || this.type === 'main-food' ? this.searchByGenre : (this.type === 'method' ? this.searchByMethod : this.searchByIngredient),
      dataOriginOptions: originOptions,
      originSelect: [],
      focusNoSelect: false
    }
  },
  computed: {
    cookList: function () : {
      cookId: string,
      name: string
      }[] {
      if (this.searchId === '' || !this.searchByCategory[this.searchId]) return []
      return Object.assign({}, this.searchByCategory[this.searchId])
    },
    title: function () : string {
      return this.type === 'cari' ? 'カレーを選ぶ' : this.type === 'main-food' ? '主食を選ぶ' : this.type === 'genre' ? 'ジャンル' : (this.type === 'method' ? '調理方法' : '材料')
    }
  },
  methods: {
    chooseCategory: function (id: string) {
      if (id === '' || !this.searchByCategory[id]) return
      this.searchId = id
      this.step = 2
    },
    backToStepChooseCategory: function () {
      this.step = 1
    },
    chooseCook: function (id: string) {
      if (!this.cooks[id]) return
      this.cookId = id
      this.step = 3
      this.originSelect = this.cooks[id].ingredients.map(x => ({
        id: x.id, origin: '不明'
      }))
    },
    backToStepChooseCook: function () {
      this.step = 2
      this.focusNoSelect = false
    },
    saveMenu: function (e: MouseEvent) {
      e.preventDefault()
      const menus = StorageAccess.getMenus()
      menus.push({
        id: generateId() as MenuId,
        name: this.cooks[this.cookId].name,
        ingredients: this.cooks[this.cookId].ingredients.map(x => ({
          id: x.id,
          name: x.name,
          grams: x.consumption,
          origin: this.originSelect.find(y => y.id === x.id)?.origin ?? x.origin
        }))
      })
      StorageAccess.setMenus(menus)
      router.push(Route.MenuList.path)
    }
  }
})
